// Sample data for testing
export const SAMPLE_DATA_ARRAY = [
  "xtnd_new","209874","C000000004268387/004","2019-11-08 14:07:54",null,"Funeral","O","23","M","8","760810","5","0","YES","2019/11/08","W","13","W","13","800819","5","0","2011/11/01","3437","YES","M","4","M","12","430101","5","0","MALE","NORTHERN CAPE","WARRENTON",null,"YES","NO",null,"000 - NOT AVAILABLE","2019/11/06",null,"M","8","O","14","WIDER","760810","5","0","0722143732","NORTHERN CAPE","HARTSWATER",null,"EMPLOYED","Government - Saps","O","14","CAPITEC BANK","3640",null,null,"L","6","P","4",null,"NO","GREGORY","WARRENTON","NORTHERN CAPE","WARRENTON","0603693077","F493465","430101","5","0","M","12","M","4","2019/11/06","WARRENTON","SINGLE","RSA","860428","5","0","O","7","M","4","CHILD","NORTHERN CAPE","WARRENTON",null,"INTERNATIO","MP0773883","000 - NOT AVAILABLE","NATURAL","WARRENTON","G665284","430101","5","0",null,null,null,null,null,null
];

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://emergeml-live-scoring.azurewebsites.net',
  ENDPOINTS: {
    SUBMIT_SCORE: '/api/score',
    GET_SCORE: '/api/score'
  }
};

// Local Storage Keys
export const STORAGE_KEYS = {
  API_KEY: 'xtnd_api_key',
  SUBMISSIONS: 'xtnd_submissions'
};